export function timeToMilitary(timeString){
    if (!timeString) return null;
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 100 + minutes;
  };
